import "core-js/modules/es.array.push.js";
import { onMounted, getCurrentInstance, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "ProtocolManagement",
  setup() {
    const router = useRouter();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      messageType: 0,
      tabs: ["消息通知", "活动通知"],
      page: 1,
      //当前页数
      size: 10,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: []
    });
    onMounted(() => {
      getMessageList();
    });
    const changeMessageType = index => {
      if (data.messageType == index) return;
      data.messageType = index;
      getMessageList();
    };

    //查询消息列表
    const getMessageList = async () => {
      const params = {
        messageType: data.messageType + 1,
        page: data.page,
        size: data.size
      };
      var res = await globalProperties.$api.getMessageList(params);
      data.list = res.records;
      data.page = res.current;
      data.total = res.total;
      data.pages = res.pages;
    };
    const currentChange = page => {
      data.page = page;
      getMessageList();
    };
    const viewDetail = index => {
      const {
        messageId,
        read
      } = data.list[index];
      router.push({
        path: "/layout/messagenotificationdetail",
        query: {
          messageId,
          read
        }
      });
    };
    return {
      data,
      changeMessageType,
      currentChange,
      viewDetail
    };
  }
};